import React from 'react'
import "./ansichtWechselKnopf.css";

/**
 * Knopf oben rechts auf allen öffentlichen Seiten (alt und neu), um dauerhaft zwischen altem und neuem Design zu wechseln.
 * Die Seite wird in einen Rahmen gelegt, an dem sich der Knopf ausrichtet.
 */
export default function AnsichtWechselKnopf({neueAnsicht, onWechseln, children}) {
    return <div className="dhaw-rahmen">
        <button type="button" className="dhaw-knopf" onClick={onWechseln}
                title={neueAnsicht ? "Dauerhaft zur alten Ansicht wechseln" : "Dauerhaft zur neuen Ansicht wechseln"}>
            <i className="pi pi-arrow-right-arrow-left" aria-hidden="true"/>
            <span>{neueAnsicht ? "Alte Ansicht" : "Neue Ansicht"}</span>
        </button>
        {children}
    </div>
}
